import Box from '@amzn/awsui-components-react/polaris/box';
import Grid from '@amzn/awsui-components-react/polaris/grid';
import * as tokens from '@amzn/awsui-design-tokens';

export default function CommonHeader() {
  return (
    <div style={{ background: tokens.colorBackgroundHomeHeader }}>
      <Box padding={{ vertical: 'xxl', horizontal: 's' }}>
        <Grid
          gridDefinition={[
            { offset: { l: 2, xxs: 1 }, colspan: { l: 8, xxs: 10 } }
          ]}
        >
          <div className="custom-home-text-inverted">
            <Box variant="h1" fontWeight="bold" padding="n" fontSize="display-l" color="inherit">
              Migration Dashboard
            </Box>
            
            <Box variant="p" fontWeight="light">
              
            </Box>
          </div>
        </Grid>
      </Box>
    </div>
  );
}